// Thin wrapper around gtag.js (loaded globally in public/index.html).
// Guards against gtag not being ready yet (ad blockers, slow network, SSR-safety).
export function trackEvent(name, params = {}) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", name, params);
}

export function trackPageView(path) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
    });
}
